import Application from "views/Customer/Application.jsx";
import CustomerShipments from "views/Customer/CustomerShipments.jsx";
import CreditCard from "views/Customer/CreditCard.jsx";

// @material-ui/icons
import PersonAdd from "@material-ui/icons/PersonAdd";

const customerRoutes = [
  {
    path: "/customer/shipments",
    name: "Shipments",
    short: "Shipments",
    mini: "SH",
    icon: PersonAdd,
    component: CustomerShipments
  },
    {
    path: "/customer/application",
    name: "Application",
    short: "Application",
    mini: "AP",
    icon: PersonAdd,
    component: Application
  },
      {
    path: "/customer/creditcard",
    name: "CreditCard",
    short: "CreditCard",
    mini: "CC",
    icon: PersonAdd,
    component: CreditCard
  },
];


export default customerRoutes;



// WEBPACK FOOTER //
// ./src/routes/customer.jsx